module.exports = __webpack_public_path__ + "static/media/test12_3.05014c30.png";